import React from 'react';
import IconFromImage from '../IconFromImage/IconFromImage';
import trianglesFavoriteSrc from './assets/trianglesFavorite.svg';

const TrianglesFavoriteIcon = () => (
    <IconFromImage type="trianglesFavorite" src={trianglesFavoriteSrc} />
);

export default TrianglesFavoriteIcon;
